module.exports = __webpack_public_path__ + "img/iphone_5.509601d9.png";